import type {
  IExportHistoryParams,
  IGetHistoryParams,
  IGetHistoryResponse,
} from "../types/history";
import type { ApiClient } from "./client";

export class HistoryApi {
  constructor(private apiClient: ApiClient) {}

  async getHistory(params: IGetHistoryParams): Promise<IGetHistoryResponse> {
    const response = await this.apiClient.get<IGetHistoryResponse>("/history", {
      params,
    });
    return response.data;
  }

  async exportHistory(params: IExportHistoryParams): Promise<Blob> {
    const response = await this.apiClient.get<Blob>("/history/export", {
      params,
      responseType: "blob",
    });
    return response.data;
  }
}
